import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from 'ng2-translate';
import { AlertOverviewService } from './services/alert-overview.service';
import { Alert } from '../../../domain/models/alert';
import { Polyline } from '../../../domain/models/polyline';
import { Job } from '../../../domain/models/job';
import { AlertType } from '../../../domain/enums/alertType';
import { Coords } from '../../../domain/models/coords';
import { PositionType } from '../../../domain/enums/positionType';
import ColorConstants from '../../constants/color-constants';

@Component({
  selector: 'app-alert-overview',
  templateUrl: './alert-overview.component.html',
  styleUrls: ['./alert-overview.component.scss']
})
export class AlertOverviewComponent implements OnInit {
  @Input() routeId: string;
  @Input() routeName: string;
  @Input() projectName: string;

  @Output() onClose = new EventEmitter<void>();

  public alerts: Alert[];
  public selectedAlert: Alert;
  public routePolyline: Polyline;

  public alertOverviewVisible: boolean;
  public addAlertVisible: boolean;
  public deleteAlertVisible: boolean;

  private expandedAlertIds: string[];
  private alertsLoading: boolean;


  constructor(
    private alertOverviewService: AlertOverviewService,
    private translateService: TranslateService) { }

  ngOnInit() {
    this.alerts = [];
    this.expandedAlertIds = [];
    this.reloadAlertOverview();
    this.drawCurrentRoute();
  }

  getAlertsForJob(): void {
    this.alertsLoading = true;
    this.alertOverviewService.getAlertsForJob(this.routeId)
      .subscribe((alerts: Alert[]) => {
        this.alerts = alerts;
        this.alertsLoading = false;
      }, (error: any) => {
        this.alertsLoading = false;
      });
  }

  private drawCurrentRoute(): void {
    if (this.routePolyline) {
      this.alertOverviewService.drawRoute(this.routePolyline);
    } else {
      this.getRoutePolyline();
    }
  }

  private getRoutePolyline(): void {
    this.alertOverviewService.getRoute(this.routeId).subscribe((result: Job) => {
      const positions = result.locations;
      let startCoords = new Coords(positions[0].y, positions[0].x);
      let endCoords = new Coords(positions[positions.length - 1].y, positions[positions.length - 1].x);
      let wayPoints: Coords[] = [];
      for (let i = 1; i < positions.length - 1; i++) {
        if (positions[i].type === PositionType.Waypoint) {
          wayPoints.push(new Coords(positions[i].y, positions[i].x));
        }
      }

      this.routePolyline = new Polyline(result.id, result.name, result.routePolyline, startCoords, endCoords, wayPoints, ColorConstants.GraphColors[0].borderColor);
      this.alertOverviewService.drawRoute(this.routePolyline);
    });
  }

  alertsAreLoading(): boolean {
    return this.alertsLoading;
  }

  hasAlerts(): boolean {
    return this.alerts && this.alerts.length > 0;
  }

  isTravelTimeAlert(alert: Alert): boolean {
    return alert.type === AlertType.TravelTime;
  }

  isTravelSpeedAlert(alert: Alert): boolean {
    return alert.type === AlertType.TravelSpeed;
  }

  hasMinDuration(alert: Alert): boolean {
    return !alert.minDuration !== undefined && alert.minDuration != null;
  }

  hasRepeat(alert: Alert): boolean {
    return alert.repeat !== undefined && alert.repeat != null;
  }

  webAlertsEnabled(alert: Alert): boolean {
    return alert.webAlertsEnabled;
  }

  toggleExpand(alertId: string) {
    let index = this.expandedAlertIds.indexOf(alertId);
    if (index >= 0) {
      this.expandedAlertIds.splice(index, 1);
    } else {
      this.expandedAlertIds.push(alertId);
    }
  }

  expanded(alertId: string): boolean {
    return this.expandedAlertIds.includes(alertId);
  }

  getAlertOverviewVisible(): boolean {
    return this.alertOverviewVisible;
  }

  getAddAlertVisible(): boolean {
    return this.addAlertVisible;
  }

  getDeleteAlertVisible(): boolean {
    return this.deleteAlertVisible;
  }

  reloadAlertOverview(): void {
    this.showAlertOverview();
    this.getAlertsForJob();
  }

  showAlertOverview(): void {
    this.selectedAlert = null;
    this.alertOverviewVisible = true;
    this.addAlertVisible = false;
    this.deleteAlertVisible = false;
  }

  showAddAlert(): void {
    this.alertOverviewVisible = false;
    this.addAlertVisible = true;
    this.deleteAlertVisible = false;
  }

  showDeleteAlert(alert: Alert): void {
    this.selectedAlert = alert;
    this.alertOverviewVisible = false;
    this.addAlertVisible = false;
    this.deleteAlertVisible = true;
  }

  onDeleteAlert(alertId: string): void {
    this.alertOverviewService.deleteAlert(alertId)
      .subscribe((result: any) => {
        this.reloadAlertOverview();
      }, (error: any) => {
        this.reloadAlertOverview();
      });
  }

  backToOverview(): void {
    this.alertOverviewService.clearMap();
    this.onClose.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/alert-overview/alert-overview.component.ts